<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fas fa-video" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Videos</h1>
		</div>
	</div>
</div>
<mat-card id="card" class="mt-2">
	<mat-card-content class="card-content">
		<div class="row">
			<div class="col-md-12">
				<!--Aqui ira la descripcion del vehiculo-->
			</div>
			<div class="col-md-12">
				<span>Especifique un rango de tiempo y el tipo de alerta para obtener la lista de videos del vehiculo
					seleccionado.</span>
			</div>
		</div>
		<mat-divider class="mt-3"></mat-divider>
		<dx-validation-group>
			<div class="row mt-3">
				<div class="col col-sm-12 col-md-12 col-lg-12 mt-3">
					<div *ngIf="!esReproduccion" class="row">
						<div class="col col-sm-12 col-md-3 col-lg-3">
							<label>Fecha Inicial</label>
							<dx-date-box [(value)]="startTime" type="datetime" style="width: 100%;"
								displayFormat="yyyy-MM-dd HH:mm:ss">
								<dx-validator>
									<dxi-validation-rule message="Campo requerido" type="required">
									</dxi-validation-rule>
								</dx-validator>
							</dx-date-box>
						</div>
						<div class="col col-sm-12 col-md-3 col-lg-3">
							<label>Fecha Final</label>
							<dx-date-box [(value)]="endTime" type="datetime" style="width: 100%;"
								displayFormat="yyyy-MM-dd HH:mm:ss">
								<dx-validator>
									<dxi-validation-rule message="Campo requerido" type="required">
									</dxi-validation-rule>
								</dx-validator>
							</dx-date-box>
						</div>
						<div class="col col-sm-12 col-md-3 col-lg-3">
							<label>Alarmas</label>
							<dx-select-box [dataSource]="listaAlarmas" displayExpr="nombre" valueExpr="id"
								[(value)]="alarma" itemTemplate="alarmas" placeholder="Selecciona alarma"
								style="width: 100%;">
								<div *dxTemplate="let alarma of 'alarmas'">
									<div class="custom-item">
										<div class="product-name">
											{{alarma.nombre}}
										</div>
									</div>
								</div>
							</dx-select-box>
						</div>
						<div class="col col-sm-12 col-md-3 col-lg-3">
							<div class="row mt-3">
								<button id="boton" type="submit" class="btn btn-success mt-3"
									(click)="obtenerArchivos()"><i class="fal fa-search"></i>Buscar</button>&nbsp;
								<button id="boton" type="submit" class="btn btn-success mt-3" (click)="abrirStream()"><i
										class="fal fa-cctv"></i>Stream</button>&nbsp;
							</div>
						</div>
					</div>
					<div *ngIf="esReproduccion" class="row">
						<div class="col col-sm-12 col-md-3 col-lg-3">
							<label>Alarmas</label>
							<dx-select-box [dataSource]="listaAlarmas" displayExpr="nombre" valueExpr="id"
								[(value)]="alarma" itemTemplate="alarmas" placeholder="Selecciona alarma"
								style="width: 100%;">
								<div *dxTemplate="let alarma of 'alarmas'">
									<div class="custom-item">
										<div class="product-name">
											{{alarma.nombre}}
										</div>
									</div>
								</div>
							</dx-select-box>
						</div>
						<div class="col col-sm-12 col-md-3 col-lg-3">
							<div class="row mt-3">
								<button id="boton" type="submit" class="btn btn-success mt-3"
									(click)="obtenerArchivos()"><i class="fal fa-search"></i>Buscar</button>&nbsp;
								<button id="boton" type="submit" class="btn btn-success mt-3" (click)="abrirStream()"><i
										class="fal fa-cctv"></i>Stream</button>&nbsp;
							</div>
						</div>
					</div>
				</div>
			</div>
		</dx-validation-group>
		<mat-divider class="mt-3"></mat-divider>
		<div id="grafica" class="grid">
			<dx-data-grid *ngIf="showTable" id="gridContainer" [dataSource]="videoArchivos" [columnHidingEnabled]="true"
				[showBorders]="true" [rowAlternationEnabled]="true">
				<dxo-paging [pageSize]="5"></dxo-paging>
				<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 50, 100]" [showInfo]="true">
				</dxo-pager>
				<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
				<dxi-column caption="Video" cellTemplate="Abrir" alignment="center" [width]="100">
				</dxi-column>
				<dxi-column dataField="deviceID" caption="Imei" alignment="center">
					<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
				</dxi-column>
				<dxi-column dataField="start" caption="Fecha y hora" cellTemplate="dateCell" alignment="center">
					<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
				</dxi-column>
				<dxi-column dataField="channel" caption="Canal" alignment="center" cellTemplate="canal">
					<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
				</dxi-column>
				<dxi-column dataField="type" caption="Alarma" alignment="center" cellTemplate="alarma">
					<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
				</dxi-column>
				<dxo-summary>
					<dxi-total-item column="deviceID" summaryType="count" [customizeText]="customizeText">
					</dxi-total-item>
				</dxo-summary>
				<div *dxTemplate="let cellData of 'dateCell'">
					{{cellData.value | date: 'yyyy-MM-dd h:mm a'}}
				</div>
				<div *dxTemplate="let c of 'canal'">
					CH{{c.value}}
				</div>
				<div *dxTemplate="let d of 'Abrir'">
					<dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones" (click)="abrirVideo(d.data)">
						<i class="fas fa-play"></i>
					</dx-button>
				</div>
				<div *dxTemplate="let a of 'alarma'">
					<span class="azul" *ngIf="a.value == 1">Almacenamiento Interno</span>
					<span class="rojo" *ngIf="a.value == 2">Puerta Abierta</span>
					<span class="naranja" *ngIf="a.value == 3">Auto Descargas</span>
				</div>
			</dx-data-grid>
			<dx-chart *ngIf="showTable" id="chart" (onPointClick)="pointClick($event)" [dataSource]="timeline"
				[rotated]="true">
				<dxo-size [height]="150">
				</dxo-size>
				<dxo-argument-axis [categories]="['Canales']">
					<dxo-tick [visible]="false"></dxo-tick>
				</dxo-argument-axis>
				<dxo-animation [enabled]="false"></dxo-animation>
				<dxo-series-template nameField="channel"></dxo-series-template>
				<dxo-legend [visible]="false"></dxo-legend>
				<dxo-common-series-settings argumentField="channel" type="rangeBar" rangeValue1Field="start"
					rangeValue2Field="stop" color="#52bb56">
				</dxo-common-series-settings>
				<dxo-tooltip container="#grafica" [enabled]="true" location="center"
					[customizeTooltip]="customizeTooltip">
					<dxo-format [precision]="shortDateShortTime"></dxo-format>
				</dxo-tooltip>
				<dxo-zoom-and-pan valueAxis="both"></dxo-zoom-and-pan>
			</dx-chart>
		</div>
	</mat-card-content>
</mat-card>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
